import React, { useState } from 'react'

import {
  Action,
  BooleanField,
  FieldSpec,
  LinkedField,
  LinkedPathField,
  NumberField,
  PaginatedTable,
  PalletASNField,
  RelatedLinkedField,
  RelatedListValueField,
  ValueField,
} from 'src/components/Table'
import { Pallet } from 'src/api/models'
import { PalletLabel } from 'src/components/PrintLabel'
import { BulkPrint } from 'src/components/Print/Bulk'
import { useAsyncPrint } from 'src/components/ToPrint/useAsyncPrint'
import { ListTableProps } from './types'

const fieldOptions: { [key: string]: FieldSpec } = {
  name: { id: 'name', label: 'Name', renderer: LinkedField(ValueField) },
  guid: { id: 'guid', label: 'SquID', renderer: ValueField },
  client: {
    id: 'client',
    label: 'Client',
    ordering: 'pallet__account__name',
    renderer: RelatedLinkedField(ValueField, 'name'),
  },
  clientID: {
    id: 'clientID',
    label: 'Client Unique ID',
    ordering: 'pallet__client_uid',
    renderer: ValueField,
  },
  skus: { id: 'skus', label: 'SKUs', renderer: RelatedListValueField('sku') },
  path: { id: 'objPath', label: 'Path', ordering: 'place__search_path', renderer: LinkedPathField },
  asn: { id: 'asn', label: 'ASN', renderer: PalletASNField },
  batch: {
    id: 'batch',
    label: 'Batch',
    ordering: 'batch__batch_type,batch__client_uid',
    renderer: RelatedLinkedField(ValueField, 'name'),
  },
  totalUnits: {
    id: 'totalUnits',
    label: 'Total Number of Units on Pallet',
    ordering: 'total_units',
    renderer: NumberField,
  },
  reviewNeeded: {
    id: 'reviewNeeded',
    label: 'Review Needed',
    ordering: 'review_needed',
    renderer: BooleanField,
  }
}

export const PalletListTable = (props: ListTableProps) => {
  const { paginator, fields, bulkActions, exportConfig } = props
  const [selected, setSelected] = useState<Pallet[]>([])
  const { print, renderPrintComponent } = useAsyncPrint()

  const bulkOptions: { [key: string]: Action } = {
    printPallet: {
      label: 'Print Pallet',
      action: () => {
        print((props) => (
          <BulkPrint
            {...props}
            items={selected}
            render={({ obj, onReadyToPrint }) => {
              onReadyToPrint?.()
              return <PalletLabel obj={obj} />
            }}
          />
        ))
      },
    },
  }

  return (
    <>
      {renderPrintComponent()}
      <PaginatedTable
        title="Pallets"
        fields={fields.map((field) => fieldOptions[field])}
        paginator={paginator}
        onSelectedItem={setSelected}
        bulkActions={bulkActions?.map((action) => bulkOptions[action])}
        filters={[
          {
            id: 'empty',
            label: 'Is Empty',
            options: { '1': 'True', '0': 'False' },
          },
        ]}
        exportConfig={exportConfig}
      />
    </>
  )
}
